module.exports = __webpack_public_path__ + "24ce6482dbaf2e81b297a33f8ad2476e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/caret-black.svg
// module id = 79
// module chunks = 0